import React from 'react';
import { BrandHeroSection } from '../BrandHeroSection/BrandHeroSection';
import { HorizontalScrollCarousel } from '../HorizontalScrollCarousel/HorizontalScrollCarousel';
import { GlacierVideoSection } from '../GlacierVideoSection/GlacierVideoSection';
import { GlacierVideoExploration } from '../MeaningfulExplorationSection/GlacierVideoExploration/GlacierVideoExploration';
import { DestinationsMap } from '../DestinationsMap/DestinationsMap';
import { CarbonNeutralSection } from '../CarbonNeutralSection';
import { OffersGrid } from '../OffersGrid/OffersGrid';
import { PremiumOffersScroll } from '../PremiumOffersScroll/PremiumOffersScroll';
import { BlogSection } from '../BlogSection/BlogSection';
import InstagramSection from '../InstagramSection';
import Footer from '../../Footer/Footer';
import { images } from '../../shared/assets';
import './AllSectionsUnified.css';

export const AllSectionsUnified: React.FC = () => {
  // Instagram posts
  const instagramPosts = [
    { src: images.film13, alt: "Instagram 1" },
    { src: images.filmVideo1, alt: "Instagram 2", isVideo: true },
    { src: images.film14, alt: "Instagram 3" },
    { src: images.film15, alt: "Instagram 4" }
  ];

  return (
    <div className="all-sections-unified">
      {/* Each section as its own independent component */}
      <BrandHeroSection />
      <HorizontalScrollCarousel />
      <GlacierVideoSection />
      <GlacierVideoExploration />
      <DestinationsMap />
      <CarbonNeutralSection />
      <OffersGrid />
      <PremiumOffersScroll />
      <BlogSection />
      <InstagramSection posts={instagramPosts} />
      <Footer variant="default" />
    </div>
  );
};